var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurlyLineLong0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 90",
    style: {
      enableBackground: "new 0 0 1440 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M-0.3,53.7c83.6-0.5,158.2-11,233.6-26c31.6-6.3,62.7-9.6,97.8-9.8c31.8-0.2,52.3,4.3,74.8,13.7 c13.7,5.7,26.8,11.7,43.8,15.7c26,6.1,52.5,4.4,80.8,2.9c36.9-1.9,73.3-3.1,110.6-2.1c39.5,1,78.2,5,117.6,6.7 c62.5,2.7,118.4-13.2,180.2-11c71.6,2.5,138.9,15,209.7,19.2c45.5,2.7,88.3-4.8,133.9-2c45.7,2.8,90.2,8,136.4,9.3 c3.3,0.1,18,2.2,21-0.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlyLineLong0);
export default __webpack_public_path__ + "static/media/curly-line-long-0.f01c4e18.svg";
export { ForwardRef as ReactComponent };